// extracted by mini-css-extract-plugin
export default {"container":"jxOpp0AWjOeOZV4kkARi","grid":"ZRSW7ykHb3U0PCdlu0y0","half":"EPBVBmJdwf4FJwYA1yKq","full":"wDtcsOdP40BQUnca0uEF"};